
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/acquisitions",
      function () {
        return require("private-next-pages/acquisitions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/acquisitions"])
      });
    }
  